import { render, staticRenderFns } from "./EditStudentModal.vue?vue&type=template&id=5eebd0d0&scoped=true&"
import script from "./EditStudentModal.vue?vue&type=script&lang=js&"
export * from "./EditStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eebd0d0",
  null
  
)

export default component.exports